import { Star } from "lucide-react";

export const BarList = ({ items, max }) => (
  <div className="space-y-2">
    {items.length === 0 && <p className="text-sm text-ink-muted">No data yet.</p>}
    {items.map((it) => (
      <div key={it.name} className="flex items-center gap-3">
        <div className="w-32 sm:w-40 truncate text-sm text-ink-soft" title={it.name}>
          {it.name}
        </div>
        <div className="flex-1 h-3 rounded-full bg-sand-deep overflow-hidden">
          <div
            className="h-full rounded-full bg-clay"
            style={{ width: `${max ? (it.count / max) * 100 : 0}%` }}
          />
        </div>
        <div className="w-8 text-right text-sm font-medium text-ink">{it.count}</div>
      </div>
    ))}
  </div>
);

export const RatingList = ({ items }) => (
  <div className="space-y-2">
    {items.length === 0 && <p className="text-sm text-ink-muted">No ratings yet.</p>}
    {items.map((it) => (
      <div key={it.name} className="flex items-center gap-3">
        <div className="w-32 sm:w-40 truncate text-sm text-ink-soft" title={it.name}>
          {it.name}
        </div>
        <span className="inline-flex items-center gap-1 text-sm font-medium text-ink">
          <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
          {it.avg}
        </span>
        <span className="text-xs text-ink-muted">({it.count})</span>
      </div>
    ))}
  </div>
);

export const StatusPill = ({ status }) => {
  const map = {
    active: "text-forest bg-forest/10",
    used: "text-ink-muted bg-sand-deep",
    expired: "text-clay bg-clay/10",
  };
  return (
    <span
      data-testid={`coupon-status-${status}`}
      className={`text-xs font-semibold uppercase tracking-wide px-2.5 py-1 rounded-full ${map[status] || map.used}`}
    >
      {status}
    </span>
  );
};
